const exportedObject = {
  getProcedimientosPssData: {},
  getProcedimientosPssLoading: false,
  getProcedimientosPssError: null,

  getMedicosData: {},
  getMedicosLoading: false,
  getMedicosError: null,
};

export default exportedObject;